/**
 * Severity Filter Pills Component
 * 
 * Multi-select filter pills for filtering conflicts by severity level.
 * Similar to the RiskFilterPills in NoShowPredictor.
 */

import React from "react";
import { tWithKeyAttr as t } from "../../../../i18nHelper";
import { TConflictSeverity, ISeverityCounts } from "../../types/conflictsDetector.types";
import styles from "../../appointmentsPage.module.css";

interface ISeverityFilterPillsProps {
  selectedSeverities: TConflictSeverity[];
  severityCounts: ISeverityCounts;
  onToggleSeverity: (severity: TConflictSeverity) => void;
}

const SeverityFilterPills: React.FC<ISeverityFilterPillsProps> = ({
  selectedSeverities,
  severityCounts,
  onToggleSeverity
}) => {
  const filters: { severity: TConflictSeverity; labelKey: string }[] = [
    { severity: 'critical', labelKey: 'CONFLICTS_FILTER_CRITICAL' },
    { severity: 'high', labelKey: 'CONFLICTS_FILTER_HIGH' },
    { severity: 'medium', labelKey: 'CONFLICTS_FILTER_MEDIUM' }
  ];

  return (
    <div className={styles.severityFilter}>
      {filters.map(({ severity, labelKey }) => {
        const isActive = selectedSeverities.includes(severity);
        const count = severityCounts[severity];
        
        return (
          <button
            key={severity}
            className={`${styles.severityFilterBtn} ${styles[`severityFilterBtn${severity.charAt(0).toUpperCase() + severity.slice(1)}`]} ${isActive ? styles.severityFilterBtnActive : ''}`}
            onClick={() => onToggleSeverity(severity)}
            aria-pressed={isActive}
          >
            {t(labelKey)} ({count})
          </button>
        );
      })}
    </div>
  );
};

export default SeverityFilterPills;
